import { render } from "./AchievementsList.vue?vue&type=template&id=78553a86"
import script from "./AchievementsList.vue?vue&type=script&lang=js"
export * from "./AchievementsList.vue?vue&type=script&lang=js"

import "./AchievementsList.vue?vue&type=style&index=0&id=78553a86&lang=scss"

import exportComponent from "/builds/rahmet/products/grading-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__